import { SurveyCard } from '@/surveys/states/surveys/survey-card';

export class PortalUser {
    readonly companyId?: number;
    readonly userAccountId?: number;
    readonly roleTypeId?: number;
    readonly showSendMessage?: boolean;
    readonly respondentTypes?: string[];
    readonly firstName?: string;
    readonly lastName?: string;
    readonly email?: string;
    readonly phone?: string;
    readonly addressLine_1?: string;
    readonly addressLine_2?: string;
    readonly addressLine_3?: string;
    readonly city?: string;
    readonly state?: string;
    readonly county?: string;
    readonly country?: string;
    readonly postalCd?: string;
    readonly companyName?: string;
    readonly activeSurveyCards?: SurveyCard[];
    readonly inActiveSurveyCards?: SurveyCard[];

    constructor(data: Partial<PortalUser> = {}) {
        this.companyId = data.companyId;
        this.userAccountId = data.userAccountId;
        this.roleTypeId = data.roleTypeId;
        this.showSendMessage = data.showSendMessage;
        this.respondentTypes = data.respondentTypes;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.phone = data.phone;
        this.addressLine_1 = data.addressLine_1;
        this.addressLine_2 = data.addressLine_2;
        this.addressLine_3 = data.addressLine_3;
        this.city = data.city;
        this.state = data.state;
        this.county = data.county;
        this.country = data.country;
        this.postalCd = data.postalCd;
        this.companyName = data.companyName;
        this.activeSurveyCards = data.activeSurveyCards;
        this.inActiveSurveyCards = data.inActiveSurveyCards;
    }
}
